import React, { useCallback, useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { RUN_REPORT, EXPORT_PDF } from '../../report-actions/constants';
import ReportFilters from '../../report-filters';
import { HOTKEY_TYPE_SELECTOR_PROPS } from '../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../report-filters/filters/dropdown/helpers';
import { ReportsContext } from '../../context';
import { Button } from 'ui-components/components/button';
import messages from './messages';
import style from './style.module.less';

const filtersProps = [HOTKEY_TYPE_SELECTOR_PROPS];

const HotkeyReferenceSheet = () => {
  const { handleHotkeyRequest } = useContext(ReportsContext);
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);
  const runReportOverride = useCallback(() => handleHotkeyRequest(RUN_REPORT), [handleHotkeyRequest]);
  const runExportOverride = useCallback(() => handleHotkeyRequest(EXPORT_PDF), [handleHotkeyRequest]);

  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <div className={style['hotkey-action-buttons']}>
        <Button onClick={runReportOverride} theme='primary'>
          <FormattedMessage {...messages.runReport} />
        </Button>

        <Button onClick={runExportOverride} theme='tertiary'>
          <FormattedMessage {...messages.exportDirectlyToPdf} />
        </Button>
      </div>
    </>
  );
};

export default HotkeyReferenceSheet;
